var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"date-renderer"},[_c('span',{staticClass:"date-renderer__date"},[_vm._v(" "+_vm._s(_setup.formatOrderedAtDate || " - ")+" ")]),_c('span',{staticClass:"date-renderer__time"},[_vm._v(" "+_vm._s(_setup.formatOrderedAtTime)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }